import React from 'react';
import { useReveal } from '../lib/useReveal';
const BONUSES = [{
  num: '01',
  title: 'Recetas Express Más Vendidas'
}, {
  num: '02',
  title: 'Kit de Decoración Fácil'
}, {
  num: '03',
  title: 'Guía de Precios y Costos'
}, {
  num: '04',
  title: 'Packaging y Presentación'
}, {
  num: '05',
  title: 'Instagram para Pasteleras'
}, {
  num: '06',
  title: 'Recetario Premium Fechas Especiales'
}];
export function BonusSection() {
  const [ref, isVisible] = useReveal();
  return <section className="py-12 md:py-16 px-6 bg-gradient-to-b from-[#fff8f9] to-[#fce7e9]/40" data-id="element-28">
      <div className="max-w-5xl mx-auto" data-id="element-29">
        <div className="text-center mb-8" data-id="element-30">
          <span className="inline-block text-[#e89aaa] text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-31">
            ♡ Bonos Exclusivos ♡
          </span>
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#6b4f3a]" data-id="element-32">
            Y además recibís estos <br className="hidden md:block" data-id="element-33" />
            <span className="italic text-[#e89aaa]" data-id="element-34">6 Bonos Exclusivos</span>
          </h2>
        </div>

        <div ref={ref} className={`reveal grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 ${isVisible ? 'is-visible' : ''}`} data-id="element-35">
          {BONUSES.map((bonus, i) => <div key={i} className="bg-white rounded-3xl p-6 border border-[#f4b6c2]/40 shadow-[0_8px_30px_rgba(232,154,170,0.06)] hover:-translate-y-1 hover:shadow-[0_15px_40px_rgba(232,154,170,0.12)] transition-all duration-500" data-id="element-36">
              <div className="flex items-center gap-3 mb-3" data-id="element-37">
                <span className="inline-block bg-[#fdf2f4] text-[#e89aaa] text-[10px] font-bold tracking-[0.2em] uppercase px-3 py-1 rounded-full" data-id="element-38">
                  ♡ Bono {bonus.num}
                </span>
              </div>
              <h3 className="text-lg md:text-xl font-serif font-bold text-[#6b4f3a] leading-tight" data-id="element-39">
                {bonus.title}
              </h3>
            </div>)}
        </div>
      </div>
    </section>;
}